import { useState } from "react";
import CommCard from "src/common/CommCard";
import { Box } from "@mui/material";
import { CommonPagination } from "src/common/CommonPagination";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import AuditTrailTableRow from "./AuditTrailTableRow";
import type { IAdmin } from "src/Types/module/admin/adminTypes";

export type IAuditTrail = {
	audit_trail_admin_id: number;
	audit_trail_admin_name: string;
	audit_trail_admin_photo: string;
	audit_trail_created_at: string;
	audit_trail_details: string;
	audit_trail_id: number;
	audit_trail_status: number;
	fair_id: number;
};

const AuditTrail = () => {
	const [id, setId] = useState("");
	const { data: admins } = useGetQueryWithTotal<IAdmin[]>({
		endPoint: `/api/admin/get/all/status/active`,
		queryKeys: ["Admins", status],
	});
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const { data, isLoading } = useGetQueryWithTotal<IAuditTrail[]>({
		endPoint: "/api/admin/audit-trail",
		queryKeys: ["audit-trail"],
		params: {
			...pagination,
			dateRange,
			admin_id: id,
		},
	});

	return (
		<CommCard
			showCardHeader
			showDateRange
			headerTitle='Audit List'
			helmetTitle='BTTF - Audit list'
			handleDateRange={(date) => {
				setDateRange(date);
			}}
			showStatus
			statusLabel='Admin List'
			statusOptions={
				admins?.data?.map((item) => ({
					id: String(item.user_admin_id),
					name: item.user_admin_name,
				})) || []
			}
			handleSelectStatus={(e) => {
				setId(e);
			}}
		>
			<AuditTrailTableRow
				data={data?.data}
				paginationSkip={pagination.skip}
				isLoading={isLoading}
			/>
			<Box p={2}>
				<CommonPagination
					total={data?.total}
					paginationCalFun={(limit: number, skip: number) => {
						setPagination({ limit, skip });
					}}
				/>
			</Box>
		</CommCard>
	);
};

export default AuditTrail;
